import createDuck from '../../lib/ducks/remoteDuck'
import NavigationApiHandler from '../../lib/api/navigation'

export default createDuck({
  namespace: 'navigation',
  store: 'links',
  fetchCallback: NavigationApiHandler.getLinks,
})
